<template>
  <div>
    <template v-if="editable">
      <b-row class="d-flex flex-wrap align-items-center mb-3">
        <b-col v-if="question.image != 0" :class="(question.content ? 'text-right' : 'text-center')">
          <b-img-lazy thumbnail :src="cdnUrl + question.image" width="256"></b-img-lazy>
        </b-col>
        <b-col v-if="question.content" class="text-left question__content">
          <div v-html="question.content.replace(/&nbsp;/g, '')"></div>
        </b-col>
      </b-row>

      <b-form-textarea
        id="textarea"
        placeholder="Write down your answer..."
        rows="5"
        max-rows="5"
        class="mt-1"
        v-on:change="inputAnswer"
      ></b-form-textarea>
    </template>
    <template v-else>
      <b-row class="d-flex flex-wrap align-items-center mb-3">
        <b-col v-if="question.image != 0" class="text-center">
          <b-img-lazy thumbnail :src="cdnUrl + question.image" width="256"></b-img-lazy>
        </b-col>
        <b-col v-if="question.content" class="text-center question__content">
          <div v-html="question.content.replace(/&nbsp;/g, '')"></div>
        </b-col>
      </b-row>

      <b-form-textarea
        id="textarea"
        :value="response.answer"
        readonly
        rows="5"
        max-rows="5"
        class="mt-1"
      ></b-form-textarea>

      <div class="exam__part__title" v-if="response.score">Điểm đạt được: {{ response.score }} điểm</div>

      <div class="exam__part__title" v-if="response.comment">Hướng dẫn làm bài</div>

      <b-form-textarea
        v-if="response.comment"
        id="textarea-comment"
        :value="response.comment"
        readonly
        rows="5"
        max-rows="5"
        class="mt-1"
      ></b-form-textarea>
    </template>
  </div>
</template>

<script>
import { APP_CONFIG } from '@/utils/constants'

export default {
  name: 'QuestionWritingText',
  props: {
    question: Object,
    editable: Boolean,
    response: Object
  },
  data() {
    return {
      cdnUrl: APP_CONFIG.cdnUrl,
    }
  },
  methods: {
    inputAnswer(evt) {
      this.$emit('selectAnswer', {
        question_id: this.question.id,
        answer: evt
      })
    },
  }
}
</script>